import { render, staticRenderFns } from "./flowstatistics.vue?vue&type=template&id=621dd57e&scoped=true&"
import script from "./flowstatistics.vue?vue&type=script&lang=js&"
export * from "./flowstatistics.vue?vue&type=script&lang=js&"
import style0 from "./flowstatistics.vue?vue&type=style&index=0&id=621dd57e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621dd57e",
  null
  
)

export default component.exports